var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Loading',{attrs:{"loading":!_vm.allModulesLoaded}},[_c('div',[_c('Header'),_c('hr'),_c('div',[_c('Summary'),_c('Experience'),_c('Projects'),_c('Contact')],1),_c('hr'),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }